"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgQuestionCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm.058 15.518l.118.014c.516.09.873.553.844 1.064l-.014.118-.01.059a1.021 1.021 0 01-2.026-.235l.014-.118.01-.059c.09-.515.554-.873 1.064-.843zM12 5.05c2.12 0 3.83 1.77 3.83 3.939 0 1.234-.414 2.168-1.355 3l-.196.164c-.21.17-.397.348-.562.532-.697.775-.945 1.547-.955 2.128l.001.13a.765.765 0 01-1.51.235l-.018-.135-.002-.029a4.005 4.005 0 01.16-1.233 5.27 5.27 0 011.185-2.12c.146-.163.304-.32.474-.473l.264-.225c.722-.585.982-1.123.982-1.974 0-1.334-1.036-2.408-2.298-2.408-1.293 0-2.298.992-2.298 2.298a.766.766 0 01-1.532 0c0-2.156 1.696-3.83 3.83-3.83z"
  }));
}

var _default = SvgQuestionCircle;
exports.default = _default;